import { AdvanceFilter } from 'components/product/product-list/AdvanceFilter'
import { useEffect, useState } from 'react'
import { INITIAL_ADVANCE_FILTER } from 'configs/product/configTableProductList'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT } from 'services/apiProduct'
import { constructOptionsSelect } from 'utils/utils'

const STATUS = [
    {
        id: 1,
        label: 'Publish',
        name: 'publish',
        value: 'publish',
    },
    {
        id: 2,
        label: 'Draft',
        name: 'draft',
        value: 'draft',
    },
]

export const AdvanceFilterContainer = ({ show, setShow, values, onSubmit }) => {
    const [filterDetail, setFilterDetail] = useState({})
    const { fetching: getBrandList } = useFetch(API_PRODUCT.BRAND_LIST)
    const { fetching: getProductTypeList } = useFetch(API_PRODUCT.TYPE_LIST)
    const { fetching: getCategoryList } = useFetch(API_PRODUCT.CATEGORY_LIST)
    const [options, setOptions] = useState({
        brand: [],
        product_type: [],
        category: [],
        status: STATUS,
    })

    const getFilterCount = () => {
        let count = 0
        Object.keys(values).map((i) => (count += values[i]?.length))
        return count
    }

    const onClear = () => {
        setFilterDetail(INITIAL_ADVANCE_FILTER)
    }

    const getAPIOption = (type, payload) => {
        switch (type) {
            case 'brand':
                return getBrandList(payload)
            case 'product_type':
                return getProductTypeList(payload)
            case 'category':
                return getCategoryList({ ...payload, childOnly: true })
            default:
                return
        }
    }

    const onSearchOptions = (type, value) => {
        getAPIOption(type, { search: value }).then((response) => {
            const newOption = constructOptionsSelect(response?.data, 'name', 'id')
            setOptions({ ...options, [type]: newOption })
        })
    }

    const onChangeForm = (e) => {
        const { name, value } = e
        setFilterDetail({ ...filterDetail, [name]: value })
    }

    useEffect(() => {
        if (show) {
            Promise.all([getBrandList(), getProductTypeList(), getCategoryList({ childOnly: true })]).then(
                (response) => {
                    const newOptions = {
                        brand: constructOptionsSelect(response[0]?.data, 'name', 'id'),
                        product_type: constructOptionsSelect(response[1]?.data, 'name', 'id'),
                        category: constructOptionsSelect(response[2]?.data, 'name', 'id'),
                    }
                    setOptions({ ...options, ...newOptions })
                },
            )
        }

        setFilterDetail(values)
    }, [show, values])

    const props = {
        show,
        setShow,
        filterDetail,
        getFilterCount,
        onChangeForm,
        onClear,
        options,
        onSearchOptions,
        onSubmit,
    }

    return <AdvanceFilter {...props} />
}
